import type { MoneyTokens } from './types';

export const money: MoneyTokens = {
  colors: {
    default: 'neutral.90',
  },
  fontWeights: {
    default: 'medium',
    strikeThrough: undefined,
    tiny: 'normal',
  },
  fontSizes: {
    defaultPart: {
      tiny: 'body.1',
      small: 'heading.0',
      medium: 'heading.1',
    },
    nonIntegerPart: {
      tiny: 'body.1',
      small: 'body.1',
      medium: 'body.2',
    },
  },
};
